export enum DocumentType {
  PrivacyNoticeMrv = 0,
  DigitalPrivacy = 1,
  ApplicationDisclosures = 2,
  ESignActConsent = 3,
  RatesAgreementsCosts = 4,
  MobileAppTermsAndConditions = 5,
  SchedulePaymentTermsAndConditions = 6,
  DonationTermsAndConditions = 7,
  RewardsTermsAndConditions = 8,
  ConsentElectronicCommunications = 9,
  CoignPrivacyPolicy = 10,
  CoignFinancialPrivacyNotice = 11,
  AccountOpeningDisclosures = 12,
  CreditProfileAuthorization = 13,
  ReceiveCallsAndSmsConsent = 14,
  MrvElectronicConsent = 15,
  BalancerTransferTermsAndConditions = 16,
  CoignBenefitsGuide = 17,
  MrvCaliforniaPrivacyNotice = 18,
}
